export function getSymmetricalDifference<T>(arrayA: T[], arrayB: T[]): T[] {
    return arrayA.filter((id) => !arrayB.includes(id)).concat(arrayB.filter((id) => !arrayA.includes(id)));
}

export function swapArrayIndices<T>(array: T[], newIndex: number, oldIndex: number): T[] {
    const swappingElement = array[oldIndex];
    const filteredArray = array.filter((element, index) => index !== oldIndex);
    return [...filteredArray.slice(0, newIndex), swappingElement, ...filteredArray.slice(newIndex)];
}

export function hasCommonElements<T>(arrayA: T[], arrayB: T[]): boolean {
    return arrayA.some((element) => arrayB.includes(element));
}
